import { AxiosError } from 'axios';

import Vue from 'vue';

type SystemError = {
  ExceptionMessage: string;
  ExceptionType: string;
  Message: string;
  StackTrace: string;
}

export function getErrorMessage(error: unknown) {
  let unwrappedError = error;

  if (isAxiosError(error) && error.response?.data) {
    unwrappedError = error.response.data;
  }

  if (isSystemError(unwrappedError)) {
    return unwrappedError.ExceptionMessage;
  }

  if (unwrappedError instanceof Error) {
    return unwrappedError.message;
  }
  // use i18n translation here for unknown error
  return (Vue as any).i18n.translate('generic.error.unknown', 'An unknown error occurred. Please try again later or contact support.');
}

function isAxiosError(error: unknown): error is AxiosError {
  return (error as AxiosError)?.isAxiosError ?? false;
}

function isSystemError(error: unknown): error is SystemError {
  if (error === null || typeof error !== 'object') {
    return false;
  }
  
  if ('ExceptionType' in error) {
    return error['ExceptionType'] === 'System.Exception';
  }
  return false;
}



